import { createStore } from "vuex";
import loginApi from '@/api/login'
import configApi from '@/api/config'
import { decryptData, encryptData } from '@/utils/encrypt';
import Cookies from 'js-cookie'

const store = createStore({
  state: {
    siderCtrl: ["1", "2", "5"],
    gIsLoading: false,
    gAllLists: null,
    config: null,
    token: "",
    user: { group: "", name: "", telephone: "", email: "", assignment: "" },
  },
  getters: {
    isLoading(state) {
      return state.gIsLoading
    },
    userName(state) {
      return state.user.name
    },
    telephone(state) {
      return state.user.telephone
    },
    email(state) {
      return state.user.email
    },
    listers(state) {
      return state.gAllLists
    },
    siders(state) {
      return state.siderCtrl
    },
    incident(state) {
      return state.config.incident
    },
    cStatus(state) {
      return state.config.incident.status
    },
    cSteps(state) {
      return state.config.incident.steps
    },
    cPhases(state) {
      return state.config.incident.phases
    },
    cSlas(state) {
      return state.config.incident.slas
    },
    qbe(state) {
      return state.config.qbe
    },
    attachment(state) {
      return state.config.attachment
    },
    format(state) {
      return state.config.format
    }
  },
  mutations: {
    setSiderOpen(state, index) {
      if (state.siderCtrl.indexOf(index) === -1) {
        state.siderCtrl.push(index);
      }
    },
    setSiderClose(state, index) {
      let idx = state.siderCtrl.indexOf(index);
      if (idx !== -1) {
        state.siderCtrl.splice(idx, 1);
      }
    },
    initGlobalLists(state, list) {
      state.gAllLists = {};
      for (let i = 0; i < list.length; i++) {
        state.gAllLists[list[i].name] = list[i];
      }
      window.localStorage.setItem("lists", encryptData(JSON.stringify(state.gAllLists)));
    },
    initIncident(state, config) {
      state.config = config;
      window.localStorage.setItem("config", encryptData(JSON.stringify(state.config)));
    },
    getGlobalLists(state) {
      state.gAllLists = JSON.parse(decryptData(window.localStorage.getItem("lists")))
    },
    getIncident(state) {
      state.config = JSON.parse(decryptData(window.localStorage.getItem("config")))
    },
    setGlobalUser(state, user) {
      state.user = user;
    },
    setGlobalLoading(state, isLoading) {
      state.gIsLoading = isLoading;
    },
    setUser(state, data) {
      state.user.name = data.userName;
      state.user.telephone = data.telephone;
      state.user.email = data.email;
      state.user.group = data.group;
      state.user.assignment = [...data.assignment];
    },
    getToken(state) {
      return state.token ? state.token : Cookies.get("token");
    },
    clearToken(state) {
      state.token = ""
      Cookies.remove('token');
    },
    clearLists(state) {
      state.token = ""
      window.localStorage.remove("lists");
    },
    setToken(state, token) {
      state.token = token;
      Cookies.set("token", token);
    },
    getInfo(state) {
      let user = decryptData(Cookies.get("user"))
      state.user.name = user.name;
      state.user.telephone = user.telephone;
      state.user.email = user.email;
      state.user.group = user.group;
      state.user.assignment = [...user.assignment];
      state.token = Cookies.get("token");
      state.gAllLists = JSON.parse(decryptData(window.localStorage.getItem("lists")))
      state.config = JSON.parse(decryptData(window.localStorage.getItem("config")))
    }
  },
  actions: {
    async fetchLists(context) {
      return configApi.lists()
        .then(res => {
          if (res.code === 0) {
            context.commit("initGlobalLists", res.data)
            return true
          } else {
            context.commit("clearLists")
            return false
          }
        })
        .catch(e => {
          console.error(e)
          this.clearLists()
          return false
        })
    },
    async fetchIncident(context) {
      return configApi.incident()
        .then(res => {
          if (res.code === 0) {
            context.commit("initIncident", res.data)
            return true
          } else {
            return false
          }
        })
        .catch(e => {
          console.error(e)
          return false
        })
    },
    async login(context, params) {
      return loginApi.login(params)
        .then(res => {
          if (res.code === 0) {
            context.commit("setToken", res.data.access)
            context.commit("setUser", res.data)
            return true
          } else {
            return false
          }
        })
        .catch(e => {
          console.error(e)
          return false
        })
    },
  }
});
export default store;
